var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'svv-plain-list-container',
    _vm.isBundlePage || _vm.pageSize === 1 ? 'svv-top-bottom-space-remover' : '',
  ],style:({
    'padding-left': _vm.containerPaddings,
    'padding-right': _vm.containerPaddings,
  })},[_c('WidgetLoader'),(
      _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
        'category' && !_vm.isBundlePage
    )?_c('div',{staticClass:"svv-plain-list-container-header",class:{
      'with-calendar-toggle-btn':
        _vm.widgetSettings.widget_style_settings.show_calendar &&
        !_vm.widgetSettings.widget_style_settings.permanently_open_calendar,
      'svv-hader-remover': _vm.isBundlePage || _vm.pageSize === 1,
    }},[_c('div',{staticClass:"svv-plain-list-header-languages-selector-container"},[(
          _vm.widgetSettings.widget_style_settings.ew_show_language_selector &&
          _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
            'category' &&
          !_vm.isBundlePage &&
          _vm.pageSize !== 1
        )?_c('LanguagesSelector'):_vm._e()],1),(_vm.openItemsList === 'events' && _vm.pageSize !== 1)?_c('div',{staticClass:"svv-plain-list-header-calendar-switch-container",class:{
        'without-lang-selector':
          !_vm.widgetSettings.widget_style_settings.ew_show_language_selector,
      }}):_vm._e()]):_vm._e(),_c('div',{class:[
      'events-data-container',
      _vm.isBundlePage || _vm.pageSize === 1 ? 'svv-min-height-remover' : '',
    ]},[(
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'category' && !_vm.isBundlePage
      )?_c('WidgetMobileControls'):_vm._e(),(
        _vm.widgetSettings.widget_style_settings.show_calendar &&
        _vm.widgetSettings.widget_style_settings.permanently_open_calendar &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'category' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'progressive' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'calendar' &&
        !_vm.widgetSettings.widget_style_settings.ew_show_top_filters &&
        !_vm.isBundlePage &&
        _vm.pageSize !== 1
      )?_c('EventsCalendar',{class:{
        'open-desktop-calendar': _vm.openDesktopCalendar,
        'permanently-open':
          _vm.widgetSettings.widget_style_settings.permanently_open_calendar,
      }}):_vm._e(),(
        _vm.widgetSettings.widget_style_settings.ew_show_top_filters &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'category' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'progressive' &&
        !_vm.isBundlePage &&
        _vm.pageSize !== 1
      )?_c('EventsFiltersMultiSelectSection'):_vm._e(),(
        _vm.openItemsList === 'events' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'category' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'progressive' &&
        !_vm.isBundlePage
      )?_c('EventsListCategories'):_vm._e(),(
        _vm.openItemsList === 'events' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'category' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view ===
          'progressive' &&
        !_vm.isBundlePage
      )?_c('EventsListProgressive'):_vm._e(),(
        _vm.openItemsList === 'events' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'progressive' &&
        _vm.widgetSettings.widget_style_settings.ew_events_list_view !==
          'category' &&
        !_vm.isBundlePage
      )?_c('EventsList'):_vm._e(),(_vm.openItemsList === 'bundles')?_c('BundlesList'):_vm._e(),(_vm.isBundlePage)?_c('BundlesListProductPage'):_vm._e(),(_vm.pageSize !== 1)?_c('WidgetPromoLogo'):_vm._e()],1),_c('MountingPortal',{attrs:{"append":"","mountTo":"body"}},[(
        _vm.widgetSettings.widget_style_settings.show_calendar && _vm.pageSize !== 1
      )?_c('div',{staticClass:"svv-mobile-panel-wrapper svv-mobile-calendar-panel",class:{ 'open-mobile-calendar': _vm.openMobileCalendar }}):_vm._e(),(_vm.openMobileFilters)?_c('div',{staticClass:"svv-mobile-filters-overlay"}):_vm._e(),(_vm.openItemsList === 'events')?_c('div',{staticClass:"svv-mobile-panel-wrapper svv-mobile-filters-panel",class:{ 'open-mobile-filters': _vm.openMobileFilters }},[_c('EventsFilters')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }